module.exports = __webpack_public_path__ + "static/img/reward1-shadowed.d9f39fa3.png";